import { localizedNumber } from "../localization/localization";

export function formatTimeAMPMLocalized(
  t: (text: string) => string,
  time: String
) {
  const am = t("common:am");
  const pm = t("common:pm");
  let [hour, minute] = time.split(":").map(Number);
  const ampm = hour >= 12 ? pm : am;
  hour = hour % 12 || 12;
  const minuteFormatted =
    minute > 0 ? `:${minute.toString().padStart(2, "0")}` : "";

  return localizedNumber(`${hour}${minuteFormatted}${ampm}`);
}

export const formatTime = (minutes: number) => {
  if (isNaN(minutes) || minutes < 0) {
    return "Invalid input";
  }

  if (minutes < 60) {
    return `${minutes} min${minutes > 1 ? "s" : ""}`;
  } else if (minutes < 1440) {
    const hours = Math.floor(minutes / 60);

    return `${hours} hour${hours > 1 ? "s" : ""}`;
  } else {
    const days = Math.floor(minutes / 1440);

    return `${days} day${days > 1 ? "s" : ""}`;
  }
};

export const calculateFutureDate = (
  confirmedAt: Date,
  maxEstimatedMins: number,
  timeZone: string
) => {
  if (isNaN(maxEstimatedMins) || maxEstimatedMins < 0) {
    throw new Error("Invalid estimated minutes");
  }
  const futureDate = new Date(confirmedAt.getTime() + maxEstimatedMins * 60000);
  const options: Intl.DateTimeFormatOptions = {
    weekday: "long",
    month: "short",
    day: "numeric",
    timeZone: timeZone,
  };

  const formattedDate = futureDate.toLocaleDateString("en-US", options);

  return formattedDate;
};

export const displayTimeLeft = (seconds: any, hrs?: boolean) => {
  let hoursLeft: any = Math.floor(seconds / 60 / 60);
  let minutesLeft: any = Math.floor(seconds / 60) - hoursLeft * 60;
  let secondsLeft: any = Math.floor(seconds % 60);
  minutesLeft =
    minutesLeft.toString().length === 1 ? "0" + minutesLeft : minutesLeft;
  secondsLeft =
    secondsLeft.toString().length === 1 ? "0" + secondsLeft : secondsLeft;
  if (hrs) {
    hoursLeft = hoursLeft.toString().length === 1 ? "0" + hoursLeft : hoursLeft;

    return `${hoursLeft}:${minutesLeft}:${secondsLeft}`;
  } else {
    return `${minutesLeft}:${secondsLeft}`;
  }
};

export const getDateForamt = (dateInput: Date | string, format: string) => {
  const date = typeof dateInput === "string" ? new Date(dateInput) : dateInput;
  let result = "";
  switch (format) {
    case "DD.MM.YYYY":
      result = `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
      break;

    case "MMM DD, YYYY":
      result = date.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
      break;

    case "ddd":
      const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      result = daysOfWeek[date.getDay()];
      break;
  }

  return result;
};

export const capitalizeFirstLetter = (str: string | undefined) => {
  if (!str) {
    return "";
  }
  if (str.length === 0) {
    return str;
  }

  return str[0].toLocaleUpperCase() + str.slice(1);
};
